import Schedule from './schedule';

export default Schedule;
